const OPTIONS = [
    {
        label: 'DASHBOARD_USERS_FILTER_ASC',
        value: 'asc'
    },
    {
        label: 'DASHBOARD_USERS_FILTER_DES',
        value: 'desc'
    }
];
export { OPTIONS };
